import { createSelector } from '@ngrx/store';
import { selectDecoratorsState } from './decorators.selector';

export const getPreviewContent = createSelector(
  selectDecoratorsState,
  (state): string | null | undefined => state.readonlyContent?.docContent
);
